<header class="l-header">
  <div class="l-header-panel" style="display: flex; flex-direction: row; justify-content: space-between; align-items: center;">
    <!-- User Selection -->
    <div *ngIf="ls.premissions?.attendanceReports && ls.usersList && ls.usersList.length > 0">
      <div class="l-flex l-flex-c t-field t-field-pad">
        <label [matTooltip]="'attendance.report.selectUser' | translate">
          <img src="../../assets/icons/drb.svg" />
        </label>

        <i class="t-sep"></i>

        <span class="t-validation-wrap l-fg1">
          <select
            [(ngModel)]="selectedUserId"
            class="t-select w100"
            (ngModelChange)="onUserChange()"
            style="text-align: center"
          >
            <ng-container *ngFor="let user of ls.usersList">
              <option [value]="user.UID">{{ user.Name }}</option>
            </ng-container>
          </select>
        </span>
      </div>
    </div>

    <!-- Back Button -->
    <div style="display: flex; flex-direction: row; justify-content: flex-end;">
      <img
        style="cursor: pointer"
        [matTooltip]="'attendance.common.home' | translate"
        height="41em"
        width="41em"
        src="../../assets/icons/exit.svg"
        (click)="goBack()"
      />
    </div>
  </div>
</header>
<aside class="l-sidebar l-flex l-column" style="height: 100%;display: flex;
    flex-direction: column; justify-content: space-between;">
  <img class="off-mobile sidebar-logo logo-3d-effect" src="../../assets/icons/logo.svg" alt="Artisan Sonics" />
</aside>
<div class="attendance-report-container">
  <!-- Header -->
  <div class="report-header">
    <h2>{{ 'attendance.report.title' | translate }}</h2>
    <div class="employee-info" *ngIf="currentEmployeeName || currentEmployeeNumber">
      <span class="employee-name" *ngIf="currentEmployeeName">{{ currentEmployeeName }}</span>
      <span class="employee-separator" *ngIf="currentEmployeeName && currentEmployeeNumber"> - </span>
      <span class="employee-number" *ngIf="currentEmployeeNumber">{{ 'attendance.report.employeeNumber' | translate }}: {{ currentEmployeeNumber }}</span>
    </div>
  </div>

  <!-- Month/Year Selection -->
  <div class="month-selector">
    <button class="nav-btn" (click)="previousMonth()" aria-label="Previous month">
      ←
    </button>

    <div class="date-display">
      <select [(ngModel)]="selectedMonth" (change)="onMonthChange()" class="select">
        <option *ngFor="let month of months" [value]="month.value">
          {{ month.label | translate }}
        </option>
      </select>
      <input
        type="number"
        [(ngModel)]="selectedYear"
        (change)="onYearChange()"
        class="year-input"
        min="2020"
        [max]="currentYear"
      />
    </div>

    <button class="nav-btn" (click)="nextMonth()" aria-label="Next month">
      →
    </button>
  </div>

  <!-- Statistics -->
  <div *ngIf="monthlyStats" class="stats-section">
    <div class="stat-card">
      <div class="stat-label">{{ 'attendance.report.totalHours' | translate }}</div>
      <div class="stat-value">{{ monthlyStats.totalWorkHours }}</div>
    </div>
    <div class="stat-card">
      <div class="stat-label">{{ 'attendance.report.totalDays' | translate }}</div>
      <div class="stat-value">{{ monthlyStats.daysWorked }}</div>
    </div>
    <div class="stat-card" *ngIf="shouldShowExams()">
      <div class="stat-label">{{ 'attendance.report.totalExams' | translate }}</div>
      <div class="stat-value">{{ monthlyStats.totalExams }}</div>
    </div>
    <div class="stat-card" >
      <div class="stat-label">{{ 'attendance.report.totalVacationDays' | translate }}</div>
      <div class="stat-value">{{ getTotalVacationDays() }}</div>
    </div>
    <div class="stat-card" >
      <div class="stat-label">{{ 'attendance.report.totalSickDays' | translate }}</div>
      <div class="stat-value">{{ getTotalSickDays() }}</div>
    </div>
    <button 
      class="export-btn"
      (click)="exportToExcel()"
      [disabled]="isLoading || monthlyRecords.length === 0"
    >
      ⬇ {{ 'attendance.report.exportExcel' | translate }}
    </button>
    <button 
      class="export-btn"
      (click)="exportToPDF()"
      [disabled]="isLoading || monthlyRecords.length === 0"
      style="background: #d9534f; margin-inline-start: 0.5em;"
    >
      ⬇ {{ 'attendance.report.exportPDF' | translate }}
    </button>
  </div>

  <!-- Add Absence Section -->
  <div  class="absence-section" style="margin: 2em 0; padding: 1em; background: #f9f9f9; border-radius: 8px;">
    <h3 style="color: #277382; margin-bottom: 1em;">{{ 'attendance.absence.title' | translate }}</h3>
    
    <button 
      class="search-btn"
      (click)="openAbsenceModal()"
      style="margin-bottom: 1em;"
    >
      ➕ {{ 'attendance.absence.addButton' | translate }}
    </button>

    <!-- Absence Records List -->
    <div *ngIf="absenceRecords && absenceRecords.length > 0" style="margin-top: 1em;">
      <table class="records-table">
        <thead>
          <tr>
            <th>{{ 'attendance.absence.startDate' | translate }}</th>
            <th>{{ 'attendance.absence.endDate' | translate }}</th>
            <th>{{ 'attendance.absence.days' | translate }}</th>
            <th>{{ 'attendance.absence.type' | translate }}</th>
            <th>{{ 'attendance.absence.reason' | translate }}</th>
            <th>{{ 'attendance.report.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let absence of absenceRecords">
            <td>{{ formatDate(absence.StartDate) }}</td>
            <td>{{ formatDate(absence.EndDate) }}</td>
            <td style="text-align: center; font-weight: 600;">{{ calculateAbsenceDays(absence) }}</td>
            <td>
              <span [ngStyle]="{'color': absence.AbsenceType === 'vacation' ? '#5cb85c' : '#f0ad4e'}">
                {{ absence.AbsenceType === 'vacation' ? ('attendance.absence.vacation' | translate) : ('attendance.absence.sick' | translate) }}
              </span>
            </td>
            <td>{{ absence.Reason || '-' }}</td>
            <td style="text-align: center;">
              <button 
                class="icon-btn"
                (click)="openAbsenceModal(absence)"
                [matTooltip]="'attendance.absence.edit' | translate"
                style="color: #277382; cursor: pointer; background: none; border: none; font-size: 18px; margin-left: 10px;"
              >
                ✏️
              </button>
              <button 
                class="icon-btn"
                (click)="openDeleteConfirmation(absence.AutoIndex)"
                [matTooltip]="'attendance.absence.delete' | translate"
                style="color: #d9534f; cursor: pointer; background: none; border: none; font-size: 18px;"
              >
                🗑️
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div *ngIf="!absenceRecords || absenceRecords.length === 0" style="text-align: center; color: #888; padding: 1em;">
      {{ 'attendance.absence.noRecords' | translate }}
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="isLoading" class="loading-spinner">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="alert alert-error">
    {{ error }}
  </div>

  <!-- Records Table -->
  <div *ngIf="!isLoading && monthlyRecords.length > 0" class="records-container">
    <div *ngFor="let dateKey of getSortedDateKeys()" class="date-group">
      <div class="date-header">
        <span>{{ dateKey }}</span>
        <span class="day-hours">
          {{ 'blocks.gui.labels.appointment_stats.Total' | translate }}: {{ calculateDayHours(getGroupedRecords()[dateKey]) }}
          <span *ngIf="shouldShowExams() && getDailyExamsCount(dateKey) > 0" style="margin-right: 15px;">
            | {{ 'attendance.report.exams' | translate }}: {{ getDailyExamsCount(dateKey) }}
          </span>
        </span>
      </div>

      <table class="records-table">
        <thead>
          <tr>
            <th>{{ 'attendance.tracker.checkIn' | translate }}</th>
            <th>{{ 'attendance.tracker.checkOut' | translate }}</th>
            <th>{{ 'attendance.report.hours' | translate }}</th>
            <th>{{ 'attendance.report.actions' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let pair of cachedGroupedRecordsWithPairs[dateKey]; let i = index">
            <!-- Check-In Column -->
            <td class="time-cell">
              <div *ngIf="pair.checkIn" class="time-display">
                {{ formatTime(pair.checkIn.CreationTime) }}
              </div>
              <div *ngIf="!pair.checkIn" class="missing-warning">
                <span class="warning-icon">⚠️</span>
                <span class="warning-text">{{ 'attendance.report.missingCheckIn' | translate }}</span>
              </div>
            </td>
            
            <!-- Check-Out Column -->
            <td class="time-cell">
              <div *ngIf="pair.checkOut" class="time-display">
                {{ formatTime(pair.checkOut.CreationTime) }}
              </div>
              <div *ngIf="!pair.checkOut" class="missing-warning">
                <span class="warning-icon">⚠️</span>
                <span class="warning-text">{{ 'attendance.report.missingCheckOut' | translate }}</span>
              </div>
            </td>
            
            <!-- Hours Column -->
            <td class="hours-cell">
              <span dir="ltr">{{ calculatePairHours(pair) }}</span>
            </td>
            
            <!-- Actions Column -->
            <td style="padding: 10px; text-align: center;">
              <!-- Button for missing check-out -->
              <button 
                *ngIf="!pair.checkOut && pair.checkIn && ls.premissions?.attendanceReports"
                type="button"
                style="background: #d9534f !important; color: white !important; padding: 8px 12px !important; cursor: pointer !important; border: none !important; border-radius: 4px !important; font-size: 14px !important; display: inline-block !important; position: relative !important; z-index: 100 !important;"
                (click)="openFixMissingTime(pair.checkIn!, dateKey)"
                [matTooltip]="'attendance.report.fixRecord' | translate">
                {{ 'attendance.report.fixRecord' | translate }}
              </button>
              
              <!-- Button for missing check-in -->
              <button 
                *ngIf="!pair.checkIn && pair.checkOut && ls.premissions?.attendanceReports"
                type="button"
                style="background: #d9534f !important; color: white !important; padding: 8px 12px !important; cursor: pointer !important; border: none !important; border-radius: 4px !important; font-size: 14px !important; display: inline-block !important; position: relative !important; z-index: 100 !important;"
                (click)="openFixMissingTime(pair.checkOut!, dateKey)"
                [matTooltip]="'attendance.report.fixRecord' | translate">
                {{ 'attendance.report.fixRecord' | translate }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- No Records -->
  <div *ngIf="!isLoading && monthlyRecords.length === 0" class="no-records">
    <p>{{ 'attendance.report.noData' | translate }}</p>
  </div>
</div>

<!-- Fix Missing Time Modal -->
<div *ngIf="showFixModal" class="print-history-popup">
  <div class="t-popup-close" (click)="closeFixModal()"></div>
  
    <div class="t-popup-body">
      <button
        class="t-btn-popup-close"
        aria-label="close popup"
        (click)="closeFixModal()"
      ></button>

      <h2 style="color: #d7a95b; text-align: center;">
        {{ fixingRecord?.CheckType === 'check-in' ? ('attendance.modal.title' | translate) : ('attendance.modal.title' | translate) }}
      </h2>

      <div style="margin: 2em 0;">
        <p style="margin-bottom: 1em; text-align: center;">{{ 'attendance.modal.date' | translate }}: {{ fixingDateKey }}</p>
        <p style="margin-bottom: 1em; text-align: center;">
          {{ fixingRecord?.CheckType === 'check-in' ? ('attendance.modal.checkIn' | translate) : ('attendance.modal.checkOut' | translate) }}: 
          {{ fixingRecord ? formatTime(fixingRecord.CreationTime) : '' }}
        </p>
        
        <div class="l-flex l-flex-c t-field t-field-pad" style="justify-content: center; margin: 1em auto; max-width: 300px;">
          <label style="color: #d7a95b; white-space: nowrap;">
            {{ fixingRecord?.CheckType === 'check-in' ? ('attendance.modal.time' | translate) : ('attendance.modal.time' | translate) }}
          </label>
          <i class="t-sep"></i>
          <input
            type="time"
            [(ngModel)]="newTime"
            class="t-field-text"
            style="text-align: center;"
            step="1"
          />
        </div>
      </div>

      <div *ngIf="fixError" style="color: #d9534f; text-align: center; margin: 1em 0; font-weight: 600;">
        {{ fixError }}
      </div>

      <div class="l-flex l-flex-w t-fieldmargin patient-details" style="gap: 0.75rem; display: flex; justify-content: space-evenly;">
        <button
          class="search-btn"
          style="width: 6em"
          [disabled]="isFixing || !newTime"
          (click)="saveMissingTime()"
        >
          <mat-spinner *ngIf="isFixing" diameter="18" strokeWidth="3" class="spinner-white" style="margin-right: 0.75rem;"></mat-spinner>
          <span *ngIf="!isFixing">{{ 'attendance.modal.save' | translate }}</span>
        </button>

        <button
          class="search-btn"
          style="width: 6em; background: #888"
          [disabled]="isFixing"
          (click)="closeFixModal()"
        >
          {{ 'attendance.modal.cancel' | translate }}
        </button>
      </div>
    </div>
  
</div>

<!-- Add Absence Modal -->
<div *ngIf="showAbsenceModal" class="print-history-popup" >
  <div class="t-popup-close" (click)="closeAbsenceModal()"></div>
  
  <div class="t-popup-body" >
    <button
      class="t-btn-popup-close"
      aria-label="close popup"
      (click)="closeAbsenceModal()"
    ></button>

    <h2 style="color: #d7a95b; text-align: center; margin-bottom: 1em;">
      {{ editingAbsenceId ? ('attendance.absence.editModalTitle' | translate) : ('attendance.absence.modalTitle' | translate) }}
    </h2>

    <!-- User Info -->
    <div style="text-align: center; margin-bottom: 2em; padding: 1em; background: #f0f8ff; border-radius: 4px;">
      <strong style="color: #277382;">{{ 'attendance.absence.forUser' | translate }}</strong>
      <div style="font-size: 1.2em; color: #015a6c; margin-top: 0.5em;">
        {{ currentEmployeeName }}
        <span *ngIf="currentEmployeeNumber" style="color: #888; font-size: 0.9em;">
          ({{ 'attendance.report.employeeNumber' | translate }}: {{ currentEmployeeNumber }})
        </span>
      </div>
    </div>

    <div style="margin: 2em 0;">
      <!-- Start Date -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.startDate' | translate }}
        </label>
        <i class="t-sep"></i>
        <input
          type="date"
          [(ngModel)]="absenceForm.startDate"
          class="t-field-text"
          style="text-align: center; flex: 1;"
        />
      </div>

      <!-- End Date -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.endDate' | translate }}
        </label>
        <i class="t-sep"></i>
        <input
          type="date"
          [(ngModel)]="absenceForm.endDate"
          class="t-field-text"
          style="text-align: center; flex: 1;"
        />
      </div>

      <!-- Absence Type -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.type' | translate }}
        </label>
        <i class="t-sep"></i>
        <select
          [(ngModel)]="absenceForm.absenceType"
          class="t-select"
          style="flex: 1;"
        >
          <option value="vacation">{{ 'attendance.absence.vacation' | translate }}</option>
          <option value="sick">{{ 'attendance.absence.sick' | translate }}</option>
        </select>
      </div>

      <!-- Reason -->
      <div class="l-flex l-flex-c t-field t-field-pad" style="margin-bottom: 1em;">
        <label style="color: #277382; min-width: 100px;">
          {{ 'attendance.absence.reason' | translate }}
        </label>
        <i class="t-sep"></i>
        <textarea
          [(ngModel)]="absenceForm.reason"
          class="t-field-text"
          style="flex: 1; min-height: 60px; resize: vertical;"
          [placeholder]="'attendance.absence.reasonPlaceholder' | translate"
        ></textarea>
      </div>
    </div>

    <div *ngIf="absenceError" style="color: #d9534f; text-align: center; margin: 1em 0; font-weight: 600;">
      {{ absenceError }}
    </div>

    <div class="l-flex l-flex-w t-fieldmargin patient-details" style="gap: 0.75rem; display: flex; justify-content: space-evenly; margin-top: 2em;">
      <button
        class="search-btn"
        style="width: 6em"
        [disabled]="isAbsenceSaving || !absenceForm.startDate || !absenceForm.endDate || !absenceForm.absenceType"
        (click)="saveAbsence()"
      >
        <mat-spinner *ngIf="isAbsenceSaving" diameter="18" strokeWidth="3" class="spinner-white" style="margin-right: 0.75rem;"></mat-spinner>
        <span *ngIf="!isAbsenceSaving">{{ 'attendance.modal.save' | translate }}</span>
      </button>

      <button
        class="search-btn"
        style="width: 6em; background: #d7a95b"
        [disabled]="isAbsenceSaving"
        (click)="closeAbsenceModal()"
      >
        {{ 'attendance.modal.cancel' | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Delete Confirmation Modal -->
<div *ngIf="showDeleteConfirmModal" class="print-history-popup">
  <div class="t-popup-close" (click)="closeDeleteConfirmation()"></div>
  
  <div class="t-popup-body">
    <button
      class="t-btn-popup-close"
      aria-label="close popup"
      (click)="closeDeleteConfirmation()"
    ></button>

    <h2 style="color: #d7a95b; text-align: center; margin-bottom: 1em;">
      אישור מחיקה
    </h2>

    <div style="text-align: center; padding: 2em; line-height: 1.8;">
      <p style="font-size: 1.1em; margin-bottom: 1em; color: #015a6c;">
        האם אתה בטוח שברצונך למחוק רשומת העדרות זו?
      </p>
      <p style="color: #d9534f; font-weight: 600;">
        ⚠️ פעולה זו אינה ניתנת לביטול
      </p>
    </div>

    <div class="l-flex l-flex-w t-fieldmargin patient-details" style="gap: 0.75rem; display: flex; justify-content: space-evenly; margin-top: 2em;">
      <button
        class="search-btn"
        style="width: 6em; background: #d7a95b;"
        (click)="confirmDeleteAbsence()"
      >
        מחק
      </button>

      <button
        class="search-btn"
        style="width: 6em; background: #277382"
        (click)="closeDeleteConfirmation()"
      >
        ביטול
      </button>
    </div>
  </div>
</div>
